import React, { useState } from 'react';
// Utils
import generateClassName from '../../../../../utils/generateClassName';
import ShowForPermission from '../../../../ShowForPermission';
// Styles
import './index.scss';

const TableHead = props => {
  const { columns, sort } = props;
  const [sortedColumn, setSortedColumn] = useState();

  const handleSort = columnName => {
    setSortedColumn(columnName);
    sort.action(columnName);
  };
  return (
    <thead className="tHeader">
      <tr>
        {columns.map(column => {
          let element = column.title;
          if (column.isSortable) {
            element = (
              <th style={{ cursor: 'pointer' }} key={column.title} onClick={() => handleSort(column.name)}>
                <i name={column.name} className={generateClassName(column.name, sortedColumn, sort.type)} />
                {element}
              </th>
            );
          }
          if (column.permission) {
            element = (
              <th>
                <ShowForPermission permission={column.permission}>{element}</ShowForPermission>
              </th>
            );
          }
          if (!column.isSortable && !column.permission) {
            return <th key={column.title}>{column.title}</th>;
          }
          return element;
        })}
      </tr>
    </thead>
  );
};

export default TableHead;
